import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Login from "@/views/Login.vue";
import Index from "@/views/Index.vue";
import Register from "@/views/Register.vue";
import Update from "@/views/UserUpdate.vue";

import Projects from "@/views/Projects.vue";
import Services from "@/views/Services.vue";
import Alerts from "@/views/Alerts.vue";
import UserGroups from "@/views/UserGroups.vue";
import Search from "@/views/Search.vue";
import Teams from "@/views/Teams.vue";
import initTeam from "@/views/InitTeam.vue";

Vue.use(VueRouter)
/**
 * 解决报错问题：报错显示是路由重复
 * Error: Avoided redundant navigation to current location
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location: import("vue-router").RawLocation) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return originalPush.call(this, location).catch(err => err)
}

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Index',
        component: Index
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/register',
        name: 'Register',
        component: Register
    },
    {
        path: '/update',
        name: 'Update',
        component: Update
    },
    {
        path: '/team',
        name: 'Teams',
        component: Teams
    },
    {
        path: '/initTeam',
        name: 'initTeam',
        component: initTeam
    },
    {
        path: '/projects',
        name: 'Projects',
        component: Projects
    },
    {
        path: '/project/:projectID/service',
        name: 'Services',
        component: Services
    },
    {
        path: '/project/:projectID/service/:serviceID/alert',
        name: 'Alerts',
        component: Alerts
    },
    {
        path: '/userGroups',
        name: 'UserGroups',
        component: UserGroups
    },

    {
        path: '/search',
        name: 'Search',
        component: Search
    },
    {
        path: '/search/:startDate/:endDate/:projectID/:serviceID/:alertID/:level/',
        name: 'Search_1',
        component: Search
    },
    {
        path: '/search/:startDate/:endDate/:projectID/:serviceID/:alertID/:level/:key/',
        name: 'Search_2',
        component: Search
    },


    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})


export default router
